import React from 'react';
import { AdminRequestsPage } from './AdminDepositsPage';
export default function AdminWithdrawalsPage() { return <AdminRequestsPage kind="withdrawals" />; }
